import React, { useEffect, useRef } from "react";
import { Icon } from "@iconify/react";

export const CHAT_ATTACHMENT_TYPES = [
  {
    key: "image",
    label: "Image",
    icon: "solar:gallery-bold",
    color: "#25d366",
  },
  {
    key: "video",
    label: "Video",
    icon: "solar:videocamera-bold",
    color: "#2196f3",
  },
  {
    key: "audio",
    label: "Audio",
    icon: "solar:music-note-bold",
    color: "#ff9800",
  },
  {
    key: "document",
    label: "Document",
    icon: "solar:document-text-bold",
    color: "#9c27b0",
  },
];

export default function ChatAttachmentMenu({
  open,
  onClose,
  onSelect,
  anchorRef,
}) {
  const panelRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      const panel = panelRef.current;
      const anchor = anchorRef?.current;
      if (panel?.contains(event.target) || anchor?.contains(event.target)) {
        return;
      }
      onClose?.();
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose, anchorRef]);

  if (!open) return null;

  return (
    <div
      className="wa-attach-menu"
      ref={panelRef}
      role="menu"
      aria-label="Attach"
    >
      {CHAT_ATTACHMENT_TYPES.map((item) => (
        <button
          key={item.key}
          type="button"
          role="menuitem"
          className="wa-attach-menu-item"
          onClick={() => {
            onSelect?.(item.key);
            onClose?.();
          }}
        >
          <span
            className="wa-attach-menu-icon"
            style={{ backgroundColor: item.color }}
          >
            <Icon icon={item.icon} width={18} color="#fff" />
          </span>
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
}
